import { ParentDeliverableViewModel } from '../../value-object/ViewModel'

export enum TimerStatus {
  MEASURING = 'measuring',
  FINISHED = 'finished',
}

export type TimerEntity = {
  userUuid: string
  taskUuid: string
  timerStatus: TimerStatus
}

export type MeasuringTimer = {
  taskName: string
  parentWbsItemName: string
  startTime: number
  wbsItemTypeUrl: string
  taskUuid: string
  parentDeliverableViewModel?: ParentDeliverableViewModel | null
}

export type TimerMeasuringTaskOfUser = {
  userUuid: string
  userName: string
  userIconUrl: string
  taskUuid: string
  taskName: string
  parentDeliverableName: string
  parentDeliverableViewModel?: ParentDeliverableViewModel | null
  startTime: number
}
